var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsetup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 138,
    viewBox: "0 0 190 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.651 0H56.7608C26.8465 0 1.16545 23.4587 0.0366159 53.4179C-1.09222 85.073 24.0244 110.793 55.3497 110.793H90.9081C93.1658 110.793 94.8591 112.489 94.8591 114.75V134.817C94.8591 137.643 98.2456 139.056 100.221 137.078L125.338 111.923C126.184 111.075 127.031 110.793 128.16 110.793H133.24C163.154 110.793 188.835 87.3341 189.964 57.3748C191.093 26.0024 165.694 0 134.651 0Z",
    fill: "#47B972"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_379_20359",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 190,
    height: 138
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.651 0H56.7608C26.8465 0 1.16545 23.4587 0.0366159 53.4179C-1.09222 85.073 24.0244 110.793 55.3497 110.793H90.9081C93.1658 110.793 94.8591 112.489 94.8591 114.75V134.817C94.8591 137.643 98.2456 139.056 100.221 137.078L125.338 111.923C126.184 111.075 127.031 110.793 128.16 110.793H133.24C163.154 110.793 188.835 87.3341 189.964 57.3748C191.093 26.0024 165.694 0 134.651 0Z",
    fill: "#47B972"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_379_20359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.195 43.4295C173.728 41.9503 172.521 40.8262 171.012 40.4593C169.509 40.0925 167.918 40.5362 166.823 41.6308L148.079 60.3689L133.731 56.2627L129.625 41.9148L148.369 23.1708C149.47 22.0762 149.907 20.4847 149.541 18.9818C149.174 17.4731 148.05 16.272 146.57 15.7987C142.784 14.6094 138.755 14 134.583 14C111.745 14 93.1667 32.5783 93.1667 55.4167C93.1667 60.2506 93.9772 64.9188 95.5807 69.3327L39.2067 125.707C35.846 129.061 34 133.517 34 138.25C34 142.983 35.846 147.439 39.2067 150.793C42.5614 154.154 47.0167 156 51.75 156C56.4833 156 60.9386 154.154 64.2933 150.793L120.667 94.4193C125.081 96.0228 129.749 96.8333 134.583 96.8333C157.422 96.8333 176 78.255 176 55.4167C176 51.2454 175.391 47.2162 174.195 43.4295Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsetup2);
export default __webpack_public_path__ + "static/media/csetup2.04bc4daa8df707b663940c88a890f57b.svg";
export { ForwardRef as ReactComponent };